const Frame147: React.FC = () => {
  return (
    <div className="w-full h-full flex items-center justify-center">
      <p className="font-sans text-2xl text-stone-800">
        Manage Access coming soon!
      </p>
    </div>
  )
};

export default Frame147;